const myJourney = {
    eyebrow: 'Experience',
    myJourney: 'Where I have been building',
    description: 'From full-stack product work to AI engineering — the teams, the problems and the stack behind each step.',
    current: 'Current',
};

export default myJourney;
